import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { chathamConfig } from "./data";

export default function ChathamPage() {
  return <CityPageTemplate config={chathamConfig} />;
}